/**
 * Created by dreamc_t on 2017/4/24.
 */
/**
 * Created by dreamc_t on 2017/4/17.
 */

import './style.scss';
import tmpl from './noVideo.ejs';
import Events from 'f.core.event';

class NoVideo {

    constructor(options, isLive,native) {
        this.options = options;
        this.isLive = isLive;
        this.native = native;
        // this.message = message;
        this.initDom();
        this.initEvent();
    }

    initDom() {
        var nowTime = new Date().valueOf();
        if (this.options.start_date > nowTime) {
            //直播未开始
            this.isLive = '0';
        } else if (nowTime > this.options.end_date) {
            this.isLive = '2'; //点播
        } else {
            this.isLive = '1';
        }

        this.el = $(tmpl({options: this.options, isLive: this.isLive}));
    }

    initEvent () {
        let self = this;
        this.goBack = this.el[0].querySelector('.linkbox');

        this.goBack.addEventListener('touchend', function () {
            if(self.native.isApp) {
                self.native.close();
            }else {
                window.open('//izhibo.ifeng.com/home.html');
            }
        });
       // this.message.on('online:info', '201', this.changeCount.bind(this));
    }
    //
    // changeCount (msg) {
    //     if (msg.code == 1) {
    //         console.log(this.el.find('.number'));
    //         this.el.find('.number').text(formatCount(msg.number));
    //     }
    // }

    renderTo(parentNode) {

        parentNode.appendChild(this.el[0]);

    }

    // show () {
    //     if(this.isShow) {
    //         $(this.el).show();
    //         this.isShow = false;
    //     }
    // }
    //
    // hide () {
    //     if(!this.isShow) {
    //         $(this.el).hide();
    //         this.isShow = true;
    //     }
    // }

}

// let formatCount = function (val) {
//     if (val < 10000) {
//         return val;
//     } else {
//         return (val / 10000).toFixed(1);
//     }
// };

Events.mixTo(NoVideo);

export  default NoVideo






// WEBPACK FOOTER //
// ./app/modules/noVideo/index.js